import request from "../../../core/wrappers/axios-wrapper";
import { ApiURL } from "../../../types/constants/apiUrls/api-urls";
import { RequestType } from "../../../types/enums/request-enums";

 
 const GetProductDetailByProductIdList = (data: any) =>
 request({
   url: ApiURL.Command.GetProductDetailByProductIdList,
   method: RequestType.POST,
   data,
 }); 


const ProductCommand = {
  GetProductDetailByProductIdList
};

export default ProductCommand;
